import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/orders/index.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/orders/show.vue') }

  static values = {
    mapKey: String
  }
}

export class PressReleaseController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/orders/press_release.vue') }

  static values = {
    orderId: String,
    automationId: String
  }

  connect() {
    super.connect({
      orderId: this.orderIdValue,
      automationId: this.automationIdValue
    })
  }
}
